import React, { Component } from 'react';
import Select from 'react-select';
import withRouter from "../../../Utils/withRouter";
import axios from "axios";
import { formatDate, } from "../../../Components/InputElements";
import Swal from "sweetalert2";
import { ConfigContext } from "../../../Context/ConfigContext";
import { NoRecords } from '../../../Components/Shimmer';

class FamilyDetailsView extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_degree: '',
      institute_university: '',
      year_of_passout: '',
      percentage_grade: '',
      employee_qualification_document: '',
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      keyword: "",
      from_date: "",
      to_date: "",
      family_Member_Name: '',
      relation: 'No',
      emergency_Contact_Person: 'Brother',
      is_Dependend: 'No',
      date_Of_Birth: '',
      gender: 'Male',
      mobile_Number: '',
      errors: {},
      data:[],
    };
    this.closeRef = React.createRef();
  }
  componentDidMount() {
    this.setState({ data: this.props.data });
  }


  handleSubmit = (e) => {
    e.preventDefault();

    const errors = this.validateForm();

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const employee_id = this.props.params.employee_id;
    var formData = {
      employee_id: employee_id,
      family_member_name: this.state.family_Member_Name,
      relation: this.state.relation,
      family_member_relation: this.state.emergency_Contact_Person,
      family_member_dependent: this.state.is_Dependend,
      family_member_dob: this.state.date_Of_Birth,
      family_member_gender: this.state.gender,
      family_member_contact_number: this.state.mobile_Number,

    }

    axios.post(`${apiURL}Employees/CreateEmployeeFamily`, formData, { headers }).then((response) => {
      const { success } = response.data;
      if (success === true) {
        this.setState({
          family_Member_Name: '',
          relation: 'No',
          emergency_Contact_Person: 'Brother',
          is_Dependend: 'No',
          date_Of_Birth: '',
          gender: 'Male',
          mobile_Number: '',
        });
        this.closeRef.current.click();
        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          timer: 2000,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      } else {
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          timer: 2000,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
      }

    })
  };
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Employees/GetEmployeeFamilies`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          employee_id: this.props.params.employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };
  handleRadioChange = (name, value) => {
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          employee_family_id: id,
          employee_id: this.props.params.employee_id,
        };
        axios
          .post(`${apiURL}Employees/DeleteEmployeeFamily`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.success === true ? "Success" : "Failed"
                }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: true }, (prevState) => {
                this.GetList();
              });
            }
          })
          .catch((error) => {
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
            });
          });
      }
    });
  };
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  handleSelectChange = (name, selectedOption) => {
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  validateForm = () => {
    const errors = {};
    const mobileRegex = /^[0-9]{10}$/;

    if (!this.state.family_Member_Name) errors.family_Member_Name = 'Family  Member Name is required';
    if (!this.state.emergency_Contact_Person) errors.emergency_Contact_Person = 'Relation is required';
    if (!this.state.is_Dependend) errors.is_Dependend = 'Dependend Field is required';
    if (!this.state.date_Of_Birth) errors.date_Of_Birth = 'Date Of Birth is required';
    if (!this.state.gender) errors.gender = 'Family Member Gender is required';
    if (!this.state.mobile_Number) errors.mobile_Number = 'Family Member Mobile number is required';
    if (this.state.mobile_Number && !mobileRegex.test(this.state.mobile_Number)) errors.mobile_Number = 'Family Member Mobile number is Invailid';
    return errors;
  };

  render() {
    const { errors } = this.state;


    return (
      <div>
        <div className='d-flex justify-content-between align-items-center'>
          <div>
            <h5>Family Details</h5>
          </div>
        </div>
        <div className="card-body">
          <table className={`table table-bordered table-stripped`}>
            <thead className="table-light">
              <tr>
                <th>Member Name</th>
                <th>Relation</th>
                <th>Date Of Birth</th>
                <th>Gender</th>
                <th>Mobile Number</th>
                <th>Dependent</th>
                {/* <th className="text-center">Action</th> */}

              </tr>
            </thead>
            {
                this.state.data?.length === 0?
                <tbody>
                        <tr>
                        <td colSpan={12}>
                            <NoRecords />
                        </td>
                        </tr>
                    </tbody>:
                    <tbody>
                    {this.state.data.map((row) => {
                      return (
                        <tr key={row.employee_family_id}>
                          <td>{row.family_member_name}</td>
                          <td>{row.family_member_relation}</td>
                          <td>{formatDate(row.family_member_dob)}</td>
                          <td>{row.family_member_gender}</td>
                          <td>{row.family_member_contact_number}</td>
                          <td>{row.family_member_dependent}</td>
                          {/* <td className="d-flex justify-content-around">
                            <button
                              onClick={() =>
                                this.handleDelete(row.employee_family_id)
                              }
                              className="btn-icon btn btn-sm btn-outline-danger"
                            >
                              {" "}
                              <i className="ri-delete-bin-line"></i>{" "}
                            </button>
                          </td> */}
                        </tr>
                      );
                    })}
                  </tbody>
            }
            
            {/* <tfoot className="table-light">
              <tr>
                <th colSpan={7}>
                  <div className="d-flex justify-content-between">
                    <button
                      disabled={this.state.prev === false && this.state.loadingList === false ? true : false}
                      type="button"
                      onClick={() => this.handlePrev()}
                      className={`btn btn-warning btn-label waves-effect waves-light`}
                    >
                      <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                      Previous
                    </button>
                    <div
                      className="col-md-4"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      {
                        <small>
                          Total Records: {this.state.total_records} |
                          Total Pages: {this.state.total_pages} |
                          Current Page: {this.state.page}
                        </small>
                      }
                    </div>
                    <div className="col-md-2">
                      <select
                        className="form-select"
                        onChange={(e) => this.handleChange(e)}
                      >
                        {Array.from(
                          { length: this.state.total_pages },
                          (_, i) => (
                            <option
                              selected={this.state.page === i + 1}
                              key={i}
                              value={i + 1}
                            >
                              Page {i + 1}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                    <button
                      disabled={
                        this.state.next === false &&
                          this.state.loadingList === false
                          ? true
                          : false
                      }
                      type="button"
                      onClick={() => this.handleNext()}
                      className={`btn btn-primary btn-label waves-effect right waves-light`}
                    >
                      <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />{" "}
                      Next
                    </button>
                  </div>
                </th>
              </tr>
            </tfoot> */}
          </table>
        </div>
      </div>

    );
  }
}

export default withRouter(FamilyDetailsView);
